// Roles del panel y lo que cada uno puede hacer. Dos ejes distintos que no
// hay que mezclar (P-FRA-13):
//
// - `isViewer` (role === "viewer") decide VISIBILIDAD: el visor es un
//   compañero operativo y no ve dinero ni datos internos.
// - `esSoloLectura` decide ESCRITURA: visor e inversionista no modifican
//   nada. El inversionista ve todo lo que ve el owner salvo la bitácora.
//
// El candado real vive en firestore.rules / storage.rules; esto solo apaga
// los puntos de entrada en la UI.

export const esViewer = (userInfo) => userInfo?.role === "viewer";

export const esInversionista = (userInfo) => userInfo?.role === "inversionista";

export const esSoloLectura = (userInfo) =>
  esViewer(userInfo) || esInversionista(userInfo);
